import(/* webpackMode: "eager" */ "/codebuild/output/src1142338333/src/apps/jumplab/src/assets/images/icons/icon-home.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1142338333/src/apps/jumplab/src/components/form/LinkButton/LinkButton.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1142338333/src/apps/jumplab/src/components/icon/FaIcon/FaIcon.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1142338333/src/apps/jumplab/src/components/ui/BreadCrumb/BreadCrumb.module.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1142338333/src/apps/jumplab/src/components/ui/ImageView/ImageView.module.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1142338333/src/apps/jumplab/src/components/layouts/CommonLoading/CommonLoading.module.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1142338333/src/apps/jumplab/src/components/ui/LoadingLink/LoadingLink.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1142338333/src/apps/jumplab/src/components/ui/MediaPlayer/MediaPlayer.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1142338333/src/apps/jumplab/src/features/article/components/ArticleHeader/ArticleHeader.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1142338333/src/apps/jumplab/src/features/article/components/ArticleTagList/ArticleTagList.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1142338333/src/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1142338333/src/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
